import { apiConcurso } from './cliente';

// ── Inscrição do produtor no concurso ──

export const obterMinhasInscricoes = () => apiConcurso.get('/api/v1/inscricoes');

export const criarInscricao = (data) => apiConcurso.post('/api/v1/inscricoes', data);

// ── Grupos disponíveis ──

export const listarGruposDisponiveis = () => apiConcurso.get('/api/v1/inscricoes/grupos-disponiveis');

// ── Produtos da inscrição ──

export const listarProdutosInscritos = () => apiConcurso.get('/api/v1/inscricoes/produtos');

export const baixarLaudoAnaliseLab = (produtoId) =>
  apiConcurso.get(`/api/v1/produtores/produtos/${produtoId}/analise-lab/laudo`, {
    responseType: 'blob',
  });

export const baixarCuradoriaAnaliseLab = (produtoId) =>
  apiConcurso.get(`/api/v1/produtores/produtos/${produtoId}/analise-lab/curadoria`, {
    responseType: 'blob',
  });

export const obterAnaliseLabProduto = (produtoId) =>
  apiConcurso.get(`/api/v1/produtores/produtos/${produtoId}/analise-lab`);

export const inscreverProduto = (data) => apiConcurso.post('/api/v1/inscricoes/produtos', data);

export const obterProduto = (produtoId) => apiConcurso.get(`/api/v1/inscricoes/produtos/${produtoId}`);

export const listarFotosMeuProduto = (produtoId) => apiConcurso.get(`/api/v1/inscricoes/produtos/${produtoId}/fotos`);

/** Fases em que o produto do produtor logado foi premiado: [{ faseConcursoId, posicaoGrupo }]. */
export const listarPremiacoesProduto = (produtoId) =>
  apiConcurso.get(`/api/v1/inscricoes/produtos/${produtoId}/premiacoes`);

export const atualizarProduto = (produtoId, data) => apiConcurso.put(`/api/v1/inscricoes/produtos/${produtoId}`, data);

export const deletarProduto = (produtoId) => apiConcurso.delete(`/api/v1/inscricoes/produtos/${produtoId}`);

// ── Contexto da inscrição (bootstrap) ──

export const obterContextoInscricao = () => apiConcurso.get('/api/v1/inscricoes/contexto');

// ── Formulário ativo da subcategoria (endpoint do produtor) ──

export const obterFormularioSubcategoria = (subcategoriaId) =>
  apiConcurso.get(`/api/v1/inscricoes/subcategorias/${subcategoriaId}/formulario`);

// ── Backoffice ──

export const listarHistoricoProduto = (produtoId) =>
  apiConcurso.get(`/api/v1/produtores/produtos/${produtoId}/historico`);
